import { Injectable } from '@angular/core';
import { Menu } from './menu.model';
import { verticalMenuItems, horizontalMenuItems, shareMenuItems } from './menu';
import { AuthenticationService } from '../../../services/AuthenticationService';
import { Subject, Subscription } from 'rxjs';

@Injectable()
export class MenuService {

  public refreshMenuSubject  = new Subject();
  private authenticatedSubscription:Subscription;

  constructor(private authService:AuthenticationService){ 
    //whenever we login or out we need to refresh the menu
    this.authenticatedSubscription = this.authService.authenticatedSubject.subscribe(()=>{
      this.refreshMenuSubject.next(undefined);
    });
  } 

  ngOnDestroy(){
    if(this.authenticatedSubscription) this.authenticatedSubscription.unsubscribe();
  }
    
  public getVerticalMenuItems():Array<Menu> {
    if(this.authService.currentUserValue) {
      verticalMenuItems.find(i=>i.id==50)!.hidden=true;
      verticalMenuItems.find(i=>i.id==60)!.hidden=true;
      verticalMenuItems.find(i=>i.id==70)!.hidden=false;
      verticalMenuItems.find(i=>i.id==80)!.hidden=false;
      if(this.authService.currentUserValue.canSeeDashboard) verticalMenuItems.find(i=>i.id==70)!.title='Dashboard'; //super admins and client users land on the dashboard
    } 
    else{
      verticalMenuItems.find(i=>i.id==50)!.hidden=false;
      verticalMenuItems.find(i=>i.id==60)!.hidden=false;
      verticalMenuItems.find(i=>i.id==70)!.hidden=true;
      verticalMenuItems.find(i=>i.id==80)!.hidden=true;
    }
    return verticalMenuItems;
  }

  public getHorizontalMenuItems():Array<Menu> {
    if(this.authService.currentUserValue) {
      horizontalMenuItems.find(i=>i.id==50)!.hidden=true;
      horizontalMenuItems.find(i=>i.id==60)!.hidden=true;
      horizontalMenuItems.find(i=>i.id==70)!.hidden=false;
      horizontalMenuItems.find(i=>i.id==80)!.hidden=false;
      if(this.authService.currentUserValue.canSeeDashboard) horizontalMenuItems.find(i=>i.id==70)!.title='Dashboard'; //super admins and client users land on the dashboard
    } 
    else{
      horizontalMenuItems.find(i=>i.id==50)!.hidden=false;
      horizontalMenuItems.find(i=>i.id==60)!.hidden=false;
      horizontalMenuItems.find(i=>i.id==70)!.hidden=true;
      horizontalMenuItems.find(i=>i.id==80)!.hidden=true;
    }
    return horizontalMenuItems;
  }

  public getShareMenuItems():Array<Menu> {
    return shareMenuItems;
  }


}